document.addEventListener("DOMContentLoaded", function () {
  const dualImageClink = document.querySelector(".dual-image-clink");
  if (!dualImageClink) return;

  function createSparkles() {
    const sections = document.querySelectorAll(".dual-image-section");

    sections.forEach((section) => {
      const sparklesContainer = document.createElement("div");
      sparklesContainer.className = "sparkles";

      for (let i = 0; i < 6; i++) {
        const sparkle = document.createElement("div");
        sparkle.className = "sparkle";
        sparkle.innerHTML = "&";
        sparklesContainer.appendChild(sparkle);
      }

      section.appendChild(sparklesContainer);
    });
  }

  function addHoverEffects() {
    const sections = document.querySelectorAll(".dual-image-section");

    sections.forEach((section) => {
      section.addEventListener("mouseenter", function () {
        this.style.transform = "scale(1.02)";
        this.style.transition = "transform 0.3s ease";
      });

      section.addEventListener("mouseleave", function () {
        this.style.transform = "scale(1)";
      });
    });
  }

  function addButtonInteractions() {
    const buttons = document.querySelectorAll(".shop-button");

    buttons.forEach((button) => {
      button.addEventListener("click", function (e) {
        const ripple = document.createElement("span");
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;

        ripple.style.width = ripple.style.height = size + "px";
        ripple.style.left = x + "px";
        ripple.style.top = y + "px";
        ripple.classList.add("ripple");

        this.appendChild(ripple);

        setTimeout(() => {
          ripple.remove();
        }, 600);
      });
    });
  }

  function addCategoryHovers() {
    const categories = document.querySelectorAll(".category-tag");

    categories.forEach((category) => {
      category.addEventListener("mouseenter", function () {
        this.style.background = "rgba(255, 255, 255, 0.4)";
        this.style.transform = "translateY(-2px) scale(1.05)";
      });

      category.addEventListener("mouseleave", function () {
        this.style.background = "rgba(255, 255, 255, 0.2)";
        this.style.transform = "translateY(0) scale(1)";
      });
    });
  }

  function initResponsiveLayout() {
    // function updateLayout() {
    //   const isDesktop = window.innerWidth >= 768;

    //   if (isDesktop) {
    //     dualImageClink.style.height = "100vh";
    //     dualImageClink.style.flexDirection = "row";
    //   } else {
    //     dualImageClink.style.height = "auto";
    //     dualImageClink.style.flexDirection = "column";
    //   }
    // }

    updateLayout();
    window.addEventListener("resize", updateLayout);
  }

  // createSparkles();
  // addHoverEffects();
  // addCategoryHovers();
  addButtonInteractions();
  initResponsiveLayout();
});

const style = document.createElement("style");
style.textContent = `
    .ripple {
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.6);
        transform: scale(0);
        animation: ripple-animation 0.6s linear;
        pointer-events: none;
    }

    @keyframes ripple-animation {
        to {
            transform: scale(4);
            opacity: 0;
        }
    }
`;
document.head.appendChild(style);
